import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  NOTE_FEATURE_KEY,
  State,
  NotePartialState,
  noteAdapter
} from './note.reducer';

// Lookup the 'Note' feature state managed by NgRx
export const getNoteState = createFeatureSelector<NotePartialState, State>(
  NOTE_FEATURE_KEY
);

const { selectAll, selectEntities } = noteAdapter.getSelectors();

export const getNotesLoaded = createSelector(
  getNoteState,
  (state: State) => state.loaded
);

export const getAppointmentNotes = createSelector(
  getNoteState,
  (state: State) => state.appointmentNotes
);

export const getNotesError = createSelector(
  getNoteState,
  (state: State) => state.error
);

export const getAllNote = createSelector(getNoteState, (state: State) =>
  selectAll(state)
);

export const getNoteEntities = createSelector(getNoteState, (state: State) =>
  selectEntities(state)
);

export const getSelectedId = createSelector(
  getNoteState,
  (state: State) => state.selectedId
);

export const getSelected = createSelector(
  getNoteEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getNotesTotalCount = createSelector(
  getNoteState,
  (state: State) => Object.keys(state.entities || {}).length
);
